class stripe extends Stripe {
  constructor() {
    //TODO: Recuerda que estos son accesos de pruebas
    super('pk_test_VfWv8crWPV57jN1jbhyPBmEQ00IA1UKKgh');
  }
  tokenize(card) {

  }
}

export default stripe;



// WEBPACK FOOTER //
// ./src/js/stripe.js